document.addEventListener("DOMContentLoaded", () => {
  const grid = document.querySelector("#product-grid");
  if (!grid) return;

  let loading = false;
  let currentPage = 1;
  let reachedEnd = false;

  // Get products per page from URL or fallback
  const productsPerPage = grid.children.length;

  const loadNextPage = async () => {
    if (loading || reachedEnd) return;

    loading = true;
    currentPage += 1;

    const url = new URL(window.location.href);
    url.searchParams.set("page", currentPage);

    try {
      const response = await fetch(url.toString());
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, "text/html");

      const newItems = doc.querySelectorAll("#product-grid > li");

      // STOP when no new products
      if (!newItems.length) {
        reachedEnd = true;
        stopInfiniteScroll();
        return;
      }

      newItems.forEach(item => grid.appendChild(item));

    } catch (error) {
      console.error("Infinite scroll error:", error);
    }

    loading = false;
  };

  const stopInfiniteScroll = () => {
    window.removeEventListener("scroll", onScroll);

    if (!document.getElementById("collection-end")) {
      const end = document.createElement("div");
      end.id = "collection-end";
      end.style.textAlign = "center";
      end.style.padding = "40px";
      end.innerText = "You’ve reached the end ✨";
      grid.after(end);
    }
  };

  const onScroll = () => {
    if (
      window.innerHeight + window.scrollY >=
      document.body.offsetHeight - 600
    ) {
      loadNextPage();
    }
  };

  window.addEventListener("scroll", onScroll);
});
